import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { initialize } from 'redux-form'
import { bindActionCreators } from 'redux'

import { SubmercadoForm } from '../../components'
import * as submercadoActionCreators from '../../redux/modules/submercado'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'

class SubmercadoFormContainer extends Component {
  static propTypes = {
    id: PropTypes.string,
    history: PropTypes.object.isRequired,
    initialize: PropTypes.func.isRequired,
    fetchSubmercado: PropTypes.func.isRequired,
    createSubmercado: PropTypes.func.isRequired,
    updateSubmercado: PropTypes.func.isRequired,
    showSuccessfulFlashMessage: PropTypes.func.isRequired,
    showErrorFlashMessage: PropTypes.func.isRequired,
    shouldHideFlashMessage: PropTypes.bool.isRequired,
    hideFlashMessage: PropTypes.func.isRequired,
    error: PropTypes.array,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    if (this.props.id) {
      const submercado = await this.props.fetchSubmercado(this.props.id)
      this.props.initialize('SubmercadoForm', {submercado})
    }
  }

  handleSubmitResource = async (submercado) => {
    if (this.props.id) {
      if (await this.props.updateSubmercado(this.props.id, submercado)) {
        this.props.showSuccessfulFlashMessage('', 'update')
        this.props.history.push('/submercados')
      } else {
        this.props.showErrorFlashMessage('', 'update', this.props.error)
      }
    } else {
      if (await this.props.createSubmercado(submercado)) {
        this.props.showSuccessfulFlashMessage('', 'create')
        this.props.history.push('/submercados')
      } else {
        this.props.showErrorFlashMessage('', 'create', this.props.error)
      }
    }
  }

  componentWillUnmount () {
    if (this.props.shouldHideFlashMessage)
      this.props.hideFlashMessage()
  }

  render () {
    return (
      <SubmercadoForm
        onSubmit={(submercado) => this.handleSubmitResource(submercado)}
        isLoading={this.props.isLoading} />
    )
  }
}

function mapStateToProps ({submercado, status, flashMessage}, {match}) {
  const { id } = match.params
  if (id) {
    return {
      id,
      submercado: submercado.get('id'),
      error: status.getIn(['submercado', 'error']),
      isLoading: status.getIn(['submercado', 'isLoading']),
      shouldHideFlashMessage: flashMessage.get('isError'),
    }
  }
  return {
    error: status.getIn(['submercado', 'error']),
    isLoading: status.getIn(['submercado', 'isLoading']),
    shouldHideFlashMessage: flashMessage.get('isError'),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...submercadoActionCreators,
    ...flashMessageAcionCreators,
    ...{initialize},
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmercadoFormContainer)
